export default __webpack_public_path__ + "static/media/IpAddressIcon.cb257698.svg";